<script lang="ts" setup>
	import ToggleDarkMode from '@/views/components/toggle-dark-mode.vue';

	// const $page = usePage();
	// const user = computed(() => $page.props.auth.user);
</script>

<template>
	<nav
		class="border-border bg-background/80 fixed top-0 z-50 w-full border-b backdrop-blur-md"
	>
		<div class="container mx-auto px-4 py-3">
			<div class="flex h-16 items-center justify-between">
				<!-- Logo / Brand -->
				<div class="flex items-center">
					<RouterLink
						:href="route('home')"
						class="from-primary to-secondary bg-linear-to-r bg-clip-text text-2xl font-bold text-transparent"
					>
						ProcessFlow
					</RouterLink>
				</div>

				<!-- Navigation Links and Actions -->
				<div class="hidden items-center space-x-8 md:flex">
					<a
						class="text-muted-foreground hover:text-foreground transition-colors"
						href="#features"
					>
						Features
					</a>
					<a
						class="text-muted-foreground hover:text-foreground transition-colors"
						href="#pricing"
					>
						Pricing
					</a>
					<a
						class="text-muted-foreground hover:text-foreground transition-colors"
						href="#contact"
					>
						Contact
					</a>
					<ToggleDarkMode />
					<Button>
						<RouterLink :href="route('login')">
							Get Started
						</RouterLink>
					</Button>
				</div>
			</div>
		</div>
	</nav>
</template>
